export class SecurityModelDTO {
    
    modelId:string
    createDate:string;
    description:string;
    modelName:string
    updateDate:string
    
    constructor(description?:string,modelName?:string){
        this.description=description;
        this.modelName=modelName;
    }

}